<template>
    <div>
        <div class="container py-5">
            <div class=" py-3">
                <div class="breadcrumbs-retos">
                    <a href="/home-bat">
                        <img src="/img/icons/homeBread.svg" alt="">
                    </a>
                    <a class="link-disable cursor-pointer" href="/mi-perfil">Mi Perfil / </a>
                    <span class="color-active-miga"><strong>Cambiar Contraseña</strong></span>
                </div>
                <a class="mt-4" href="/home-bat"><img src="/img/icons/regresar.svg" alt="icon"></a>
            </div>

            <div class="header-catalog mt-2">
                <h5>Cambiar Contraseña</h5>
            </div>
        </div>
        <div class="form-changepass container-md py-2 mx-auto mb-5">

            <form @submit.prevent="submitForm" class="efade in" id="formRegister">
                <div class="row py-3 form-pass">
                    <div class="col-md-6 d-flex flex-column password-group">
                        <label for="password" class="password-label"
                            :class="{ 'text-danger': !passwordValid && errors.length > 0, 'focus': passwordFocused }">Escribir
                            contraseña
                            nueva</label>
                        <div class="pass-ch my-3"
                            :class="{ 'is-invalid': !passwordValid && errors.length > 0, 'focus': passwordFocused }">
                            <input v-model="password" :type="showPassword ? 'text' : 'password'" id="password"
                                name="password" autocomplete="off" @focus="passwordFocused = true"
                                @blur="passwordFocused = false">
                            <div class="eye" @click="togglePasswordVisibility('password')"></div>
                        </div>
                    </div>


                    <div class="col-md-6 d-flex flex-column password-group">
                        <label for="password1" class="password1-label"
                            :class="{ 'text-danger': !passwordValid && errors.length > 0, 'focus': password1Focused }">Repetir
                            contraseña</label>
                        <div class="pass-ch my-3"
                            :class="{ 'is-invalid': !passwordValid && errors.length > 0, 'focus': password1Focused }">
                            <input v-model="passwordConfirm" :type="showPasswordConfirm ? 'text' : 'password'"
                                id="password1" name="repetir_password" autocomplete="off"
                                @focus="password1Focused = true" @blur="password1Focused = false">
                            <div class="eye" @click="togglePasswordVisibility('passwordConfirm')"></div>
                        </div>
                    </div>
                </div>

                <div class="content py-3 nivel-seguridad">
                    <label>Nivel de seguridad:
                        <span class="indicator"
                            :class="{ 'bajo-text': password.length > 0 && password.length < 8, 'medio-text': password.length >= 8 && !isStrongPassword, 'alto-text': isStrongPassword }"
                            id="password-strength-status">{{ passwordStrength }}</span>
                    </label>
                    <div class="barIndicator">
                        <div :class="getDivClass(1)">
                        </div>
                        <div :class="getDivClass(2)">
                        </div>
                        <div :class="getDivClass(3)">
                        </div>
                    </div>
                </div>
                <div class="row py-3 verificacion">
                    <div class="col-lg-2 col-md-6 field-ver">
                        <div id="mayuscula" :class="{'check': !hasUpperCase, 'check-tick': hasUpperCase}"></div>
                        <span  class="mayuscula dataOff">Mayúscula</span>
                    </div>

                    <div class="col-lg-2 col-md-6 field-ver">
                        <div id="minuscula" :class="{'check': !hasLowerCase, 'check-tick': hasLowerCase}"></div>
                        <span  class="minuscula dataOff">Minúscula</span>
                    </div>

                    <div class="col-lg-2 col-md-6 field-ver">
                        <div :class="{'check': !hasNumber, 'check-tick': hasNumber}"></div>
                        <span id="numero" class="numero dataOff">Número</span>
                    </div>

                    <div class="col-lg-2 col-md-6 field-ver">
                        <div :class="{'check': !hasMinLength, 'check-tick': hasMinLength}"></div>
                        <span id="longitud" class="longitud dataOff">Carácteres mínimos 8</span>
                    </div>
                    <div class="col-lg-2 col-md-6"></div>
                </div>

                <div>
                    <div v-if="errors.length > 0">
                        <ul class="px-0">
                            <li class="error" v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>

                    <div v-if="message" class="error">{{ message }}</div>

                    <div class="row py-3 check-politicas">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12 mb-3 d-flex">
                                    <input v-model="tratamientoDeDatos" type="checkbox" name="tratamiento_de_datos"
                                        id="tratamiento_de_datos">
                                    <span class="ps-1">Acepto la <a href="/tratamiento-datos">política de
                                            tratamiento
                                            de datos y términos y condiciones</a></span>
                                </div>

                                <div class="col-md-12 mb-3 d-flex">
                                    <input v-model="mayorDeEdad" type="checkbox" name="mayor_de_edad"
                                        id="mayor_de_edad">
                                    <span class="ps-1">Soy mayor de edad</span>
                                </div>
                                <input id="user-info" name="user-info" type="hidden" v-model="userInfo">
                            </div>
                        </div>

                        <div class="col-md-6 d-flex justify-content-end boton">
                            <button class="btnBlue px-5">Cambiar contraseña</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <el-dialog :visible.sync="innerVisible" :center="true" :width="widthModal()" class="dialog-mobile">
            <div class="text-center">
                <img src="/img-version2/icons/staff/dangerstaff.svg" width="110px" alt="image 8">
                <h6 class="text-bat">¿Estás seguro de cambiar tu contraseña?</h6>
            </div>
            <div class="dialog-footer mb-3 text-center">
                <div class="p-3">
                    <button class="w-50 mx-1 btn btnBlue text-title-bat rounded-3" @click="confirmChangePassword">
                        Sí, cambiar contraseña
                    </button>
                </div>
                <div>
                    <a type="button" class="w-50 fs-6 mt-2 border-2 text-btn-outstanding"
                        @click="innerVisible = !innerVisible">Cancelar</a>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="innerVisibleExit" :center="true" :width="widthModal()" class="dialog-mobile" @close="closeExit()">
            <div class="text-center">
                <img src="/img-version2/modal/tick-circle.svg" width="110px" alt="image 8">
                <h6 class="text-bat"> Tu contraseña ha sido actualizada con éxito</h6>
                <a class="w-50 mx-1 btn btnBlue text-title-bat rounded-3" href="/home-bat">Aceptar</a>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="show_password_expired_modal" :center="true" :width="widthModal()" class="dialog-mobile">
            <div class="text-center">
                <img src="/img-version2/modal/close-circle.svg" width="110px" alt="image 8">
                <h6 class="my-3">Contraseña expirada</h6>
                <p class="mt-3 adver">Por favor actualícela para seguir disfrutando de Conecta2 </p>
            </div>
            <div class="dialog-footer mb-3 text-center">
                <div class="p-3">
                    <button class="w-50 mx-1 btn btnBlue text-title-bat rounded-3" @click="show_password_expired_modal = !show_password_expired_modal">
                        Actualizar contraseña
                    </button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        user_id: {
            default: null,
        },
        show_password_expired_modal: {
            default: false,
        }
    },
    data() {
        return {
            password: '',
            passwordConfirm: '',
            showPasswordUpdatedModal: false,
            showPassword: false,
            showPasswordConfirm: false,
            errors: [],
            message: '',
            tratamientoDeDatos: false,
            mayorDeEdad: false,
            hasUpperCase: false,
            hasLowerCase: false,
            hasNumber: false,
            hasMinLength: false,
            passwordValid: true,
            passwordFocused: false,
            password1Focused: false,
            innerVisible: false,
            innerVisibleExit: false,
            userInfo: null,
        };
    },
    computed: {
        isStrongPassword() {
            return (
                this.hasMinLength &&
                this.hasNumber &&
                this.hasUpperCase &&
                this.hasLowerCase
            );
        },
        passwordStrength() {
            if (this.password.length === 0) return 'No aplica';
            else if (this.password.length > 0 && this.password.length < 8) return 'Bajo';
            else if (this.isStrongPassword) return 'Fuerte';
            else return 'Medio';
        }
    },
    watch: {
        password(newValue) {
            this.validate();
        }
    },
    methods: {
        togglePasswordVisibility(field) {
            if (field === 'password') {
                this.showPassword = !this.showPassword;
            } else if (field === 'passwordConfirm') {
                this.showPasswordConfirm = !this.showPasswordConfirm;
            }
        },
        toggleValidation(type) {
            switch (type) {
                case 'uppercase':
                    this.hasUpperCase = !this.hasUpperCase;
                    break;
                case 'lowercase':
                    this.hasLowerCase = !this.hasLowerCase;
                    break;
                case 'number':
                    this.hasNumber = !this.hasNumber;
                    break;
                case 'minlength':
                    this.hasMinLength = !this.hasMinLength;
                    break;
                default:
                    break;
            }
            this.validate();
        },

        validate() {
            const regexUpperCase = /([A-Z])/;
            const regexLowerCase = /([a-z])/;
            const regexNumber = /([0-9])/;

            this.hasUpperCase = regexUpperCase.test(this.password);
            this.hasLowerCase = regexLowerCase.test(this.password);
            this.hasNumber = regexNumber.test(this.password);
            this.hasMinLength = this.password.length >= 8;
        },
        getDivClass(index) {
            const strengthClasses = {
                Bajo: ['bajo', '', ''],
                Medio: ['medio', 'medio', ''],
                Fuerte: ['alto', 'alto', 'alto']
            };
            const strength = this.passwordStrength;
            const classes = strengthClasses[strength];

            if (classes && Array.isArray(classes) && index >= 1 && index <= classes.length) {
                return classes[index - 1];
            }
            return '';
        },
        submitForm() {
            this.errors = [];
            this.message = '';

            let valid = true;

            this.passwordValid = !!this.password.trim();
            if (!this.passwordValid) {
                this.errors.push('El campo contraseña es obligatorio');
                valid = false;
            }

            this.passwordConfirmValid = !!this.passwordConfirm.trim();
            if (!this.passwordConfirmValid) {
                this.errors.push('El campo repetir contraseña es obligatorio');
                valid = false;
            }

            if(this.password.length < 8 || ! this.hasLowerCase || ! this.hasUpperCase || ! this.hasNumber){
                this.errors.push('La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula y un número.');
                valid = false;
            }

            if (this.password !== this.passwordConfirm) {
                this.errors.push('Las contraseñas no coinciden');
                valid = false;
            }

            if (!this.tratamientoDeDatos) {
                this.errors.push('Debes aceptar la política de tratamiento de datos y términos y condiciones.');
                valid = false;
            }
            if (!this.mayorDeEdad) {
                this.errors.push('El campo soy mayor de edad es obligatorio');
                valid = false;
            }
            if (valid) {
                this.openModal();
            } else {
                this.innerVisible = false;
            }
        },
        openModal() {
            this.innerVisible = true;
        },
        confirmChangePassword() {
            this.innerVisible = false;

            const postData = {
                user_info: this.user_id,
                password: this.password,
                repetir_password: this.passwordConfirm,
                tratamiento_de_datos: this.tratamientoDeDatos,
                mayor_de_edad: this.mayorDeEdad
            };

            axios.post('/guardar-password', postData)
                .then(response => {
                    //this.message = response.data.message;
                    this.password = '';
                    this.passwordConfirm = '';
                    this.errors = [];

                    this.innerVisibleExit = true;
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.errors = Object.values(error.response.data.errors || {}).flat();
                        if(error.response.data.message){
                            this.message = error.response.data.message;
                        }
                    } else {
                        this.message = 'Hubo un error al procesar su solicitud.';
                    }
                });
        },
        widthModal() {
            let width = '90%'
            if (this.$mq === 'md') {
                width = '60%'
            } else if (this.$mq === 'lg') {
                width = '50%'
            } else if (this.$mq === 'xl') {
                width = '30%'
            }
            return width
        },

        closeExit(){
            window.location = `/home-bat`;
            this.innerVisibleExit = false;
        },
    }
};
</script>
